import { defineMessages } from 'react-intl';

export const spotlightMessages: {
	step1Title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	step1Content: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	step2Title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	step2Content: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepCounter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	step1Title: {
		id: 'jira-space-dashboard-guide.step1-title.nonfinal',
		defaultMessage: 'Classic reports are still here',
		description: 'Title for the first step of the reports dropdown spotlight',
	},
	step1Content: {
		id: 'jira-space-dashboard-guide.step1-content.nonfinal',
		defaultMessage:
			'Your existing reports haven\u2019t gone anywhere. Find them easily and switch back anytime.',
		description: 'Content for the first step of the reports dropdown spotlight',
	},
	step2Title: {
		id: 'jira-space-dashboard-guide.step2-title.nonfinal',
		defaultMessage: 'New customizable dashboard',
		description: 'Title for the second step of the reports dropdown spotlight (admin only)',
	},
	step2Content: {
		id: 'jira-space-dashboard-guide.step2-content.nonfinal',
		defaultMessage:
			'Tailor your reporting, adding widgets and rearranging elements to create a personalized view of what matters most in your space.',
		description: 'Content for the second step of the reports dropdown spotlight (admin only)',
	},
	nextButton: {
		id: 'jira-space-dashboard-guide.next-button.nonfinal',
		defaultMessage: 'Next',
		description: 'Next button text for the reports dropdown spotlight',
	},
	dismissButton: {
		id: 'jira-space-dashboard-guide.dismiss-button.nonfinal',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button text for the reports dropdown spotlight',
	},
	stepCounter: {
		id: 'jira-space-dashboard-guide.step-counter.nonfinal',
		defaultMessage: '{current} of {total}',
		description: 'Step counter for multi-step spotlight, e.g. 1 of 2',
	},
});
